import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { AuthContextProps } from "react-oidc-context";
import { AppError } from "shared/components/global/AppError/AppError";
import { CenteredBryxLoader } from "shared/components/global/Loaders/BryxLoader";
import { NotFound } from "shared/components/global/NotFound/NotFound";
import { AccessibilityDevPanel } from "shared/devtools/AccessibilityDevPanel";
import { AsideProvider } from "shared/utils/aside";

type AuthRouterContext = {
    auth: Promise<AuthContextProps>;
};

const Component = () => {
    const hideDevtools = import.meta.env.VITE_ENVIRONMENT == "prod" || import.meta.env.VITE_DISABLE_DEVTOOLS == "true";

    return (
        <AsideProvider>
            {!hideDevtools && (
                <>
                    <TanStackRouterDevtools position="top-right" initialIsOpen={false} />
                    <ReactQueryDevtools buttonPosition="top-left" position="right" initialIsOpen={false} />
                    <AccessibilityDevPanel />
                </>
            )}
            <Outlet />
        </AsideProvider>
    );
};

/** @public */
export const Route = createRootRouteWithContext<AuthRouterContext>()({
    errorComponent: AppError,
    notFoundComponent: NotFound,
    component: Component,
    pendingComponent: () => <CenteredBryxLoader />,
});
